module.exports = __webpack_public_path__ + "static/media/syd-blue-bg.4549b4c1.svg";